import {
  CampaignStage,
  EnvelopeSubmissionType,
  SPECIAL_CHARACTERS,
} from '@urbanx/agx-ui-components';
import { CampaignDetailModelStage } from '@urbanx/agx.campaigns.client';
import { getEnumValue } from 'helpers/enumHelper';

export const getInvalidSubmissionStage = (
  stage: CampaignDetailModelStage | null | undefined
) =>
  getEnumValue(
    CampaignDetailModelStage,
    stage ?? CampaignDetailModelStage.AgreementDraft
  ) !== CampaignDetailModelStage.AgreementSignedByAllParties;

export const getSubmissionTypeText = (
  type: EnvelopeSubmissionType | null | undefined
) => {
  switch (type) {
    case EnvelopeSubmissionType.Manual:
      return 'Manual Submission';
    case EnvelopeSubmissionType.DocuSign:
      return 'Docusign';
    case EnvelopeSubmissionType.Email:
      return 'Email';
    default:
      return '';
  }
};

export const getCampaignStageLabel = (stage: unknown) =>
  CampaignStage[stage as keyof typeof CampaignStage]?.split(
    SPECIAL_CHARACTERS.BULLET
  )[1] ?? '';
